import { render } from "./medium-kanban.vue?vue&type=template&id=1b70cb1e"
import script from "./medium-kanban.vue?vue&type=script&lang=js"
export * from "./medium-kanban.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__